export default __webpack_public_path__ + "static/media/heart.3a29e95c.svg";